import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatCommonModule } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { SignaturePadModule } from 'angular2-signaturepad';

import { PepperiModule } from '@pepperi/ngx-lib';
import {
    PepperiIconModule,
    PepperiIconRegistry,
    pepperiIconIndicatorDotPlaceholder } from '@pepperi/ngx-lib/icon';

import { PepperiDialogModule } from '@pepperi/ngx-lib/dialog';

import { PepperiAddressModule } from '@pepperi/ngx-lib/address';
import { PepperiAttachmentModule } from '@pepperi/ngx-lib/attachment';
import { PepperiCheckboxModule } from '@pepperi/ngx-lib/checkbox';
import { PepperiDateModule } from '@pepperi/ngx-lib/date';
import { PepperiImageModule } from '@pepperi/ngx-lib/image';
import { PepperiImagesFilmstripModule } from '@pepperi/ngx-lib/images-filmstrip';
import { PepperiInternalButtonModule } from '@pepperi/ngx-lib/internal-button';
// import { PepperiInternalPageModule } from '@pepperi/ngx-lib/internal-page';
import { PepperiMenuModule } from '@pepperi/ngx-lib/menu';
import { PepperiQuantitySelectorModule } from '@pepperi/ngx-lib/quantity-selector';
import { PepperiRichHtmlTextareaModule } from '@pepperi/ngx-lib/rich-html-textarea';
import { PepperiSelectModule } from '@pepperi/ngx-lib/select';
import { PepperiSeparatorModule } from '@pepperi/ngx-lib/separator';
import { PepperiSignatureModule } from '@pepperi/ngx-lib/signature';
import { PepperiTextareaModule } from '@pepperi/ngx-lib/textarea';
import { PepperiTextboxModule } from '@pepperi/ngx-lib/textbox';

const pepperiComponentsModules = [
    PepperiAddressModule,
    PepperiAttachmentModule,
    PepperiCheckboxModule,
    PepperiDateModule,
    PepperiImageModule,
    PepperiImagesFilmstripModule,
    PepperiInternalButtonModule,
    // PepperiInternalPageModule,
    PepperiMenuModule,
    PepperiQuantitySelectorModule,
    PepperiRichHtmlTextareaModule,
    PepperiSelectModule,
    PepperiSeparatorModule,
    PepperiSignatureModule,
    PepperiTextareaModule,
    PepperiTextboxModule,
];

import { PepperiFormComponent } from './form.component';
import { PepperiFieldGeneratorComponent } from './field-generator.component';
import { PepperiIndicatorsComponent } from './indicators.component';
import { PepperiInternalPageComponent } from './internal-page.component';
import { PepperiInternalListComponent } from './internal-list.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        // Material modules,
        MatCommonModule,
        MatGridListModule,
        MatIconModule,
        MatMenuModule,
        // External modules
        SignaturePadModule,
        // Pepperi modules
        PepperiModule,
        PepperiDialogModule,
        PepperiIconModule,
        pepperiComponentsModules,
    ],
    exports: [PepperiFormComponent],
    declarations: [
        PepperiFormComponent,
        PepperiFieldGeneratorComponent,
        PepperiIndicatorsComponent,
        PepperiInternalPageComponent,
        PepperiInternalListComponent
    ],
})
export class PepperiFormModule {
    constructor(private pepperiIconRegistry: PepperiIconRegistry) {
        this.pepperiIconRegistry.registerIcons([
            pepperiIconIndicatorDotPlaceholder
        ]);
    }
}
